import Vue from 'vue';

export const globalEventBus = new Vue();

// Mantengo una traccia degli eventi che possono essere gestiti
export const globalEventNames = {
    cultureChanged: 'cultureChanged',
    errorsChanged: 'errorsChanged'
};